module.exports = __webpack_public_path__ + "static/media/box1.b825aa82.jpeg";